export const intrenText = `As an Intren, i worked with senior developer and teams in building
scalable software for clients which as been deployed online, I have
build enough confidence working on a real project and teams.`;

export const introText = `I am a software developer, who has solid 
  understanding in software development and love to build stuff,
  I love contributing to open source project
  and to make impacts.`;
